module.exports = "/static/media/map-icon-white.c63c49af.png";